import React from 'react';
import { useParams } from 'react-router-dom';

const ClientPortal: React.FC = () => {
  const { token } = useParams<{ token: string }>();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Client Portal
          </h1>
          <p className="text-gray-600 mb-8">
            Your SEO analytics and campaign performance dashboard
          </p>
          
          {token && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
              <p className="text-blue-800">
                Loading analytics for token: {token}
              </p>
            </div>
          )}
          
          <div className="bg-white rounded-xl shadow-sm p-8">
            <h2 className="text-xl font-semibold mb-4">Coming Soon</h2>
            <p className="text-gray-600">
              The client portal is being migrated from the current Google Apps Script implementation.
              This will include all the features from the current client portal:
            </p>
            <ul className="text-left mt-4 space-y-2 max-w-md mx-auto">
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Progressive analytics loading
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                SEO recommendations
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                GMB integration
              </li>
              <li className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                White-label customization
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientPortal;
